/*eslint-disable multiline-ternary */
import React, { useState } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import './styles.scss';

const AddNewMedia = (props) => {
  //let url = useRef('');
  const [isValid, setisValid] = useState(false);

  const updateInputValue = (event) => {
    const url = event.target.value;
    const result = validateURL(url);
    if (result !== true && url !== '') {
      setisValid(true);
    } else {
      setisValid(false);
    }
    props.onChangeMediaLink(url, props.index, result);
  };

  const validateURL = (str) => {
    const regex = new RegExp(
      '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?',
    );
    const val = regex.test(str);
    return val;
  };

  const placeholder =
    props.media.MediaType === 'Facebook'
      ? 'Enter Facebook URL'
      : null || props.media.MediaType === 'YouTube'
      ? 'Enter Youtube URL'
      : null || props.media.MediaType === 'LinkedIn'
      ? 'Enter LinkedIn URL'
      : null || props.media.MediaType === 'Twitter'
      ? 'Enter Twitter URL'
      : null || props.media.MediaType === 'Android'
      ? 'Enter Android URL'
      : null || props.media.MediaType === 'iPhone'
      ? 'Enter IOS URL'
      : null;

  return (
    <Form>
      <Row className="link-card">
        <Col md={6} lg={6} sm={6}>
          <Form.Group controlId="formContentTypeMedia">
            <Form.Control
              readOnly
              name="mediaType"
              defaultValue={props.media.MediaType}
            ></Form.Control>
          </Form.Group>
        </Col>
        <Col md={6} lg={6} sm={6}>
          <Form.Group controlId="formLinkTitle">
            <Form.Control
              name="mediaURL"
              type="text"
              value={props.media.URL}
              className={isValid === true ? 'errorUrl' : null}
              onChange={(event) => updateInputValue(event)}
              //ref={url}
              placeholder={placeholder}
              disabled={props.disable}
            ></Form.Control>

            {isValid === true ? (
              <span className="invalidUrl" role="alert">
                URL is not valid
              </span>
            ) : null}
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

export default AddNewMedia;
